import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { DIALOG_VERSION, DIALOG_VERSION_KEY } from './dialog-version';

@Injectable({
  providedIn: 'root'
})
export class WelcomeDialogDataService {

  private _closeDialog = new Subject<boolean>();
  public closeDialog$: Observable<boolean> = this._closeDialog.asObservable();

  closeDialog(): void {
    this._closeDialog.next(true);
  }

  showDialog(): boolean {
    const version = localStorage.getItem(DIALOG_VERSION_KEY);
    return version === null || version !== DIALOG_VERSION;
  }

}
